export const FETCH_SELECT_REQUEST = '@selectPagination/FETCH_SELECT_REQUEST';
export const APPEND_SELECT_DATA = '@selectPagination/APPEND_SELECT_DATA';
export const SET_SELECT_LOADING = '@selectPagination/SET_SELECT_LOADING';
export const RESET_SELECT_DATA = '@selectPagination/RESET_SELECT_DATA';

export const SEARCH_SELECT_REQUEST = '@selectPagination/SEARCH_SELECT_REQUEST';
export const SEARCH_SELECT_SUCCESS = '@selectPagination/SEARCH_SELECT_SUCCESS';
export const SEARCH_SELECT_FAILURE = '@selectPagination/SEARCH_SELECT_FAILURE';
export const CLEAR_SEARCH_SELECT = '@selectPagination/CLEAR_SEARCH_SELECT';
